export default {
  errorHeading: {
    id: 'checkout_partners_error_heading',
    defaultMessage: 'Something went wrong.',
  },
  errorParagraph: {
    id: 'checkout_partners_error_paragraph',
    defaultMessage:
      "We couldn't add the product to your cart. Please go back to the partner website and try again.",
  },
}
